/* eslint-disable-next-line import/prefer-default-export */
export const GENERIC_ERROR = {
  message: { translationId: 'errors.unspecified' },
};
